import {z} from 'zod';

const metadata = z.record(z.string(), z.unknown());

export const ecommerceProductSchema = z.object({
    productId: z.number(),
    productCode: z.string(),
    name: z.string(),
    price: z.number(),
    brand: z.string(),
    category: z.string(),
    variant: z.string(),
    quantity: z.number(),
    changedQuantity: z.number().nullable(),
    dimension12: z.string(),
    list: z.string(),
    currency: z.string(),
    discount: z.number().nullable(),
    basePrice: z.number().nullable(),
    metadata: z.union([z.array(metadata), metadata]).nullable(),
    make: z.string().nullable(),
    compatibleProductCodes: z.string(),
    orderable: z.boolean().nullable(),
});

export type EcommerceProduct = z.infer<typeof ecommerceProductSchema>;
